// src/App.js - FINAL (no /leaderboard route, only /2026/leaderboard)
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PredictionForm from './components/PredictionForm';
import RacesList from './components/RacesList';
import Results from './pages/Results';
import DebugPage from './pages/DebugPage';
import AdminResultsPage from './pages/AdminResultsPage';
import Roadmap from './pages/Roadmap';
import ResetPassword from './pages/ResetPassword';
import SetupHike from './pages/SetupHike';
import UpdateHike from './pages/UpdateHike';
import HikeReport from './pages/HikeReport';

// 2025 Season Components (Read-Only)
import Predictions2025 from './pages/Predictions2025';
import Leaderboard2025 from './pages/Leaderboard2025';
import Results2025 from './pages/Results2025';

// 2026 Season Components (Full Access)
import Predictions2026 from './pages/Predictions2026';
import Leaderboard2026 from './pages/Leaderboard2026';
import Results2026 from './pages/Results2026';
import Stats2026 from './pages/Stats2026';

// Components
import Header from './components/Header';
import AdminPanel from './pages/AdminPanel';
import ProtectedRoute from './components/ProtectedRoute';
import { useContext } from 'react';
import { AuthContext } from './context/AuthContext';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';

import './App.css';

function App() {
  const { loading } = useContext(AuthContext);
  return (
    <Router>
      <div className="App">
        <Header />
        <div className="main-content">
          {!loading && (
            <Routes>
            {/* Home & Auth */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Admin Routes */}
            <Route path="/admin" element={<ProtectedRoute element={<AdminPanel />} />} />
            <Route path="/admin/debug" element={<DebugPage />} />
            <Route path="/admin/debug/:raceId" element={<DebugPage />} />
            <Route path="/admin/results-explorer" element={<AdminResultsPage />} />

            {/* General Pages */}
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />

            {/* Hiking Routes */}
            <Route path="/hike/setup" element={<SetupHike />} />
            <Route path="/hike/update" element={<UpdateHike />} />
            <Route path="/hike/report" element={<HikeReport />} />

            {/* Legacy Routes (for backward compatibility) */}
            <Route path="/races" element={<RacesList />} />
            <Route path="/predictions/:raceId" element={<PredictionForm />} />

            {/* ======================================== */}
            {/* 2025 SEASON - READ ONLY ACCESS */}
            {/* ======================================== */}
            <Route path="/predictions" element={<Predictions2025 />} />
            <Route path="/2025/leaderboard" element={<Leaderboard2025 />} />
            <Route path="/results" element={<Results2025 />} />
            <Route path="/results/:raceId" element={<Results2025 />} />

            {/* ======================================== */}
            {/* 2026 SEASON - FULL ACCESS */}
            {/* ======================================== */}
            <Route path="/2026/predictions" element={<Predictions2026 />} />
            <Route path="/2026/predictions/:raceId" element={<Predictions2026 />} />
            <Route path="/2026/leaderboard" element={<Leaderboard2026 />} />
            <Route path="/2026/results" element={<Results2026 />} />
            <Route path="/2026/results/:raceId" element={<Results2026 />} />
            <Route path="/2026/stats" element={<Stats2026 />} />
            <Route path="/2026/stats/:raceId" element={<Stats2026 />} />

            {/* Redirect old routes */}
            <Route path="/leaderboard" element={<Navigate to="/2026/leaderboard" replace />} />
            <Route path="/2025/leaderboard" element={<Navigate to="/2026/leaderboard" replace />} />
          </Routes>
          )}
        </div>
      </div>
    </Router>
  );
}

export default App;